import { Component } from '@angular/core';
import { filterEmpresas } from '../utils/filter';
import { firstValueFrom } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewDireccionModalComponent } from '../busqueda-usuario/modals/view-direccion-modal.component';
import { ViewEmpresaModalComponent } from '../busqueda-usuario/modals/view-empresa-modal.component';
import { CompanyService } from './services/company-service.service';
import { Company } from './interfaces/compani.inteface';
import { DeactivationReasonModalComponent } from './modals/deactivation-reason-modal/deactivation-reason-modal.component';
import Swal from 'sweetalert2';
import { etiquetaProductoTexto } from 'src/app/empresa/utils/etiquetas-producto.util';

@Component({
    selector: 'app-busqueda-empresa',
    templateUrl: './busqueda-empresa.component.html',
    styleUrls: ['./busqueda-empresa.component.css'],
})
export class BusquedaEmpresaComponent {
    constructor(
        private companyService: CompanyService,
        private modalService: NgbModal
    ) {}

    empresas: Company[];
    searchTerm = '';
    filteredCompanies: Company[];
    etiquetaProductoTexto = etiquetaProductoTexto;
    async ngOnInit() {
        this.mostrarEmpresas();
    }

    async mostrarEmpresas() {
        try {
            const data =
                await this.companyService.GetCompanies('agente-vigilado');
            this.empresas = data;
            this.filterCompanies();
        } catch (error) {
            console.error('Error al obtener empresas:', error);
            this.empresas = [];
        }
    }
    filterCompanies() {
        this.filteredCompanies = filterEmpresas(this.searchTerm, this.empresas);
    }

    abrirModalVerDireccion(empresaId: number): void {
        if (!empresaId) {
            console.warn('ID de empresa no válido para ver dirección.');
            return;
        }

        const modalRef = this.modalService.open(ViewDireccionModalComponent, {
            size: 'lg',
            centered: true,
            scrollable: true,
        });

        modalRef.componentInstance.empresaId = empresaId;

        modalRef.result.then(
            (result) => {
                console.log(`Modal cerrado con resultado: ${result}`);
            },
            (reason) => {
                console.log(`Modal descartado por: ${reason}`);
            }
        );
    }

    abrirModalVerEmpresa(empresaId: number): void {
        if (!empresaId) {
            console.warn('ID de empresa no válido para ver detalles.');
            return;
        }

        const modalRef = this.modalService.open(ViewEmpresaModalComponent, {
            size: 'lg',
            centered: true,
            scrollable: true,
        });

        modalRef.componentInstance.empresaId = empresaId;
        modalRef.componentInstance.nombreRepresentante = '';

        modalRef.result.then(
            (result) => {
                console.log(
                    `Modal de empresa cerrado con resultado: ${result}`
                );
            },
            (reason) => {
                console.log(`Modal de empresa descartado por: ${reason}`);
            }
        );
    }
    /**
     * Método para actualizar el estado de una empresa (activar/desactivar).
     * En caso de desactivación, abre un modal para seleccionar el motivo.
     *
     * @param empresaID Código identificador de la empresa
     * @param estado Activo o Desactivado
     * @returns
     */
    async actualizarEstado(empresaID: number, estado: string) {
        const empresa = this.empresas.find((e) => e.id === empresaID);
        const nombreEmpresa = empresa?.razonSocial || 'la empresa';

        const nuevoEstado = estado === 'Activo' ? 'Desactivado' : 'Activo';
        const url = `agente-vigilado/activar-o-desactivar-empresa?empresaID=${empresaID}`;

        if (nuevoEstado === 'Desactivado') {
            // Aquí se abre el modal para obtener el motivo de desactivación
            const modalRef = this.modalService.open(
                DeactivationReasonModalComponent,
                {
                    size: 'lg',
                    centered: true,
                    scrollable: true,
                }
            );

            try {
                const { motivo, otroMotivo } = await firstValueFrom(
                    modalRef.closed
                );

                const body = {
                    estado: nuevoEstado,
                    motivo,
                    otroMotivo,
                };
                await this.companyService.PatchCompany(url, body);
                Swal.fire({
                    icon: 'success',
                    title: 'Empresa inactivada',
                    text: `Se ha inactivado exitosamente la empresa “${nombreEmpresa}”.`,
                });

                await this.mostrarEmpresas();
                return;
            } catch {
                Swal.fire({
                    icon: 'info',
                    title: 'Acción cancelada',
                    text: 'No se realizó la inactivación de la empresa.',
                    showConfirmButton: true,
                });
                return;
            }
        }
        /**
         * Caso de activación (no requiere motivo)
         */
        try {
            await this.companyService.PatchCompany(url, {
                estado: nuevoEstado,
            });
            Swal.fire({
                icon: 'success',
                title: 'Empresa activada',
                text: `Se ha activado exitosamente la empresa “${nombreEmpresa}”.`,
            });
            await this.mostrarEmpresas();
        } catch (error) {
            console.error(
                'Error al actualizar estado del agente vigilado:',
                error
            );
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Ocurrió un error al actualizar el estado de la empresa.',
            });
        }
    }
}
